document.addEventListener("DOMContentLoaded", () => {
  const modals = document.querySelectorAll("[data-video-modal]");

  modals.forEach((section) => {
    const trigger = section.querySelector(".video-modal__trigger");
    const backdrop = section.querySelector("[data-video-modal-backdrop]");
    const content = section.querySelector("[data-video-modal-content]");
    const closeBtn = section.querySelector("[data-video-modal-close]");

    if (!trigger || !backdrop || !content) return;

    const video = section.querySelector(".video-modal__inner video");
    if (!video) return;

    function openModal() {
      const clone = video.cloneNode(true);
      clone.removeAttribute("id");
      clone.setAttribute("controls", "");
      clone.setAttribute("autoplay", "");
      clone.style.width = "100%";
      clone.style.maxHeight = "80vh";

      content.innerHTML = "";
      content.appendChild(clone);
      backdrop.classList.add("is-active");
      document.body.style.overflow = "hidden";
      if (window.lenisInstance) window.lenisInstance.stop();
    }

    function closeModal() {
      backdrop.classList.remove("is-active");
      document.body.style.overflow = "";
      if (window.lenisInstance) window.lenisInstance.start();

      const activeVideo = content.querySelector("video");
      if (activeVideo) {
        activeVideo.pause();
        activeVideo.removeAttribute("src");
        activeVideo.load();
      }
      content.innerHTML = "";
    }

    trigger.addEventListener("click", openModal);
    closeBtn?.addEventListener("click", closeModal);

    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && backdrop.classList.contains("is-active")) {
        closeModal();
      }
    });
  });
});
